<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
           <template>
              <b-row>
                <b-col lg="12" sm="12" class="text-center mb-3">
                  <h5 class='complain-title'>{{ $t('production_store.production_stock_manage') }}</h5>
                </b-col>
              </b-row>
                <b-row>
                  <b-col lg="12" sm="12">
                    <b-row>
                      <b-col lg="12" sm="12">
                        <b-table-simple striped bordered small>
                          <b-tr>
                            <b-th width="200px">{{ $t('production_store.stock_id') }}</b-th>
                            <b-td width="200px">{{ formData.stock_id }}</b-td>
                            <b-th width="200px">{{ $t('production_store.stock_date') }}</b-th>
                            <b-td>{{ formData.stock_date | dateFormat }}</b-td>
                          </b-tr>
                          <b-tr>
                            <b-th >{{ $t('production_store.comment') }}</b-th>
                            <b-td colspan="3">{{ ($i18n.locate === 'bn') ? formData.comment_bn : formData.comment }}</b-td>
                          </b-tr>
                        </b-table-simple>
                      </b-col>
                      <b-col lg="12" sm="12" class="text-center mb-3">
                        <h5 class='complain-title'>{{ $t('production_store.product_list') }}</h5>
                      </b-col>
                      <b-col>
                        <table class="table table-bordered">
                          <tr class="bg-light">
                            <th width="100px" rowspan="2" style="vertical-align:middle;">{{ $t('globalTrans.sl_no') }}</th>
                            <th rowspan="2" style="vertical-align:middle;">{{ $t('production_store.pro_category') }}</th>
                            <th rowspan="2" style="vertical-align:middle;">{{ $t('production_store.pro_name') }}</th>
                            <th rowspan="2" style="vertical-align:middle;">{{ $t('production_store.prod_quantity') }}</th>
                            <th colspan="2" class="text-center">{{ $t('production_store.raw_material_grade') }}</th>
                            <th rowspan="2" style="vertical-align:middle;">{{ $t('production_store.weight') }}</th>
                            <th rowspan="2" style="vertical-align:middle;">{{ $t('production_store.total_raw_material') }}</th>
                          </tr>
                          <tr class="bg-light">
                            <th class="text-center">{{ $t('production_store.polythin') }}</th>
                            <th class="text-center">{{ $t('production_store.fresh') }}</th>
                          </tr>
                          <tr v-for="(item, index) in formData.mat_details" :key="index">
                              <td>{{ $n(index + 1) }}</td>
                              <td>{{ getCategoryName(item.product_id) }}</td>
                              <td>{{ productNameById(item.product_id) }}</td>
                              <td>{{ $n(item.quantity) }}</td>
                              <td>{{ $n(item.fresh) }}</td>
                              <td>{{ $n(item.polythin) }}</td>
                              <td>{{ $n(item.weight) }}</td>
                              <td>{{ $n(item.total) }}</td>
                          </tr>
                        </table>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
            </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: ['id'],
  data () {
    return {
      formData: {
        mat_details: [],
        stock_date: '',
        stock_id: '',
        comment: '',
        comment_bn: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  created () {
    if (this.id) {
      const tmp = this.getProductData()
      this.formData.mat_details = tmp.stock_details
      this.formData.stock_id = tmp.stock_id
      this.formData.stock_date = tmp.stock_date
      this.formData.comment = tmp.comment
      this.formData.comment_bn = tmp.comment_bn
    }
  },
  methods: {
    getProductData () {
      const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
      return JSON.parse(JSON.stringify(tmpData))
    },
    productNameById (id) {
        const product = this.productCommonObj.productList.find(product => product.value === id)
        if (this.$i18n.locale === 'bn') {
            return product.text_bn
        } else {
            return product.text_en
        }
    },
    getCategoryName (Id) {
      const product = this.productCommonObj.productList.find(product => product.value === Id)
      if (typeof product !== 'undefined') {
        const Obj = this.productCommonObj.productCategoryList.find(el => el.value === product.category_id)
        return typeof Obj !== 'undefined' ? (this.$i18n.locale === 'en' ? Obj.text_en : Obj.text_bn) : ''
      }
      return ''
    }
  }
}
</script>
